import React, { useState } from 'react';
//import './login.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState(''); 
    const [error, setError] = useState('');
    const [stage, setStage] = useState('email'); 
    const [code, setCode] = useState('');
    const [userInputCode, setUserInputCode] = useState('');
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setEmail(e.target.value);
        setError(''); // Clear error when input changes
    };

    const validateEmail = () => {
        if (!email) {
            return 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            return 'Email is invalid';
        }
        return '';
    };

    // Here we link it with the database
    const handleEmailSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior
    
        const validationError = validateEmail();
        if (validationError) {
            setError(validationError);
        } else {
            try {
                const response = await fetch('http://<aws-endpoint>:5000/send-reset-code', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email }),
                });
                const data = await response.json();
    
                if (response.ok && data.message === 'Code sent successfully') {
                    setCode(data.code); // Save the code for local verification
                    setStage('code'); // Move to the code verification stage
                } else {
                    setError(data.message || 'Failed to send code');
                }
            } catch (error) {
                console.error('Error:', error);
                setError('Something went wrong. Please try again later.');
            }
        }
    };

    const handleCodeVerification = (e) => {
        e.preventDefault();
        if (userInputCode === code) {
            alert('Code verified! You can now reset your password.');
            setStage('password'); // Move to the password reset stage
        } else {
            setError('Invalid code. Please try again.');
        }
    };

    
    return (
        <div className="login-page">
            <img src="/LOGO_TECHE.png" alt="Logo" className="login-logo" />
            <div className="login-container">
            {stage === 'email' && (
                <form onSubmit={handleEmailSubmit} className="form">
        <h2>Forgot Password</h2>
        <p>Enter the email associated with your account.</p>
        <div className="form-group">
            <label>Email:</label>
            <input
                type="email"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder="Enter your email"
            />
            {error && <p className="error">{error}</p>}
        </div>
        <button type="submit" className="button">Send Reset Code</button>
    </form>
)}
{stage === 'code' && (
    <form onSubmit={handleCodeVerification} className="form">
        <h2>Verify Code</h2>
        <p>We sent a 6-digit code to your email. Please enter it below:</p>
        <div className="form-group">
            <label>Code:</label>
            <input
                type="text"
                value={userInputCode}
                onChange={(e) => setUserInputCode(e.target.value)}
                placeholder="Enter the code"
            />
            {error && <p className="error">{error}</p>}
        </div>
        <button type="submit" className="button">Verify Code</button>
        <button
            type="button"
            className="button-link"
            onClick={handleEmailSubmit}
        >
            Resend Code
        </button>
    </form>
)}
{stage === 'password' && (
    <form className="form">
        <h2>Reset Password</h2>
        <p>Enter your new password below:</p>
        <div className="form-group">
            <label>New Password:</label>
            <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
            />
        </div>
        <button className="button">Update Password</button>
    </form>
)}
</div>
</div>
);
};

export default ForgotPassword;